import React, { Fragment, useCallback, useState } from 'react';
import { withAreaGetter } from 'providers/AreasConsumers';
import { useRouteMatch } from 'react-router-dom';
import { areas } from 'constants/areas';
import { getInt } from 'utils/functions';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import AccountStatementContainer from './AccountStatementContainer';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_ACCOUNT_STATEMENT_READ, ADMIN_ACCOUNT_STATEMENT_WRITE } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';
import { DUPLICATE_ACCOUNT_STATEMENT } from '../mutations';
import { ACCOUNT_STATEMENT_DUPLICATED } from '../subscriptions';
import { useMutation, useSubscription } from 'hooks/apollo';
import { useSimpleError } from 'hooks/apolloWrappers';

const Route = ({ getElemByAreaKey }) => {
  const [title, setTitle] = useState('');
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const configId = match.params.id && getInt(match.params.id);
  const showError = useSimpleError();

  const onChangeTitle = useCallback(accountStatementTitle => {
    setTitle(accountStatementTitle);
  }, []);

  const onClickClose = useCallback(() => {
    historyContext.push(`/accountStatement`);
  }, [historyContext]);

  const [duplicate] = useMutation(DUPLICATE_ACCOUNT_STATEMENT, {
    skip: !configId
  });
  useSubscription(ACCOUNT_STATEMENT_DUPLICATED, {
    onError: error => showError(error),
    onData: ({ data: { data } }) => {
      onRedirect(data.accountStatementDuplicated.configId);
    }
  });

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/accountStatement/${id}`);
    },
    [historyContext]
  );

  const canWrite = usePermission(ADMIN_ACCOUNT_STATEMENT_WRITE);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} duplicate={duplicate} configId={configId} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_ACCOUNT_STATEMENT_READ}>
        <AccountStatementContainer canWrite={canWrite} configId={configId} onRedirect={onRedirect} onChangeTitle={onChangeTitle} />
      </PermissionCheck>
    </Fragment>
  );
};
Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};
export default withAreaGetter(Route);
